"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.initialValues = void 0;
var react_1 = __importDefault(require("react"));
var BillingAddress2Field_1 = __importDefault(require("./BillingAddress2Field"));
var BillingAddressField_1 = __importDefault(require("./BillingAddressField"));
var BillingFirstNameField_1 = __importDefault(require("./BillingFirstNameField"));
var BillingLastNameField_1 = __importDefault(require("./BillingLastNameField"));
var CardCVVField_1 = __importDefault(require("./CardCVVField"));
var CardExpMonthField_1 = __importDefault(require("./CardExpMonthField"));
var CardExpYearField_1 = __importDefault(require("./CardExpYearField"));
var CardNumberField_1 = __importDefault(require("./CardNumberField"));
var CityField_1 = __importDefault(require("./CityField"));
var StateField_1 = __importDefault(require("./StateField"));
var ZipCodeField_1 = __importDefault(require("./ZipCodeField"));
var FormRow_1 = __importDefault(require("../FormRow"));
exports.initialValues = {
    billingFirstName: '',
    billingLastName: '',
    cardNumber: '',
    expMonth: '',
    expYear: '',
    cvv: '',
    billingAddress: '',
    billingAddress2: '',
    billingCity: '',
    billingState: '',
    billingZipCode: '',
};
function PaymentForm(props) {
    var _a = props.layout, layout = _a === void 0 ? 'default' : _a;
    var monthYearCvv = (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(CardExpMonthField_1.default, __assign({ required: true }, props.expMonth)),
        react_1.default.createElement(CardExpYearField_1.default, __assign({ required: true }, props.expYear)),
        react_1.default.createElement(CardCVVField_1.default, __assign({ required: true }, props.cvv))));
    var cityStateZipcode = (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(CityField_1.default, __assign({ name: 'billingCity', required: true }, props.billingCity)),
        react_1.default.createElement(StateField_1.default, __assign({ name: 'billingState', required: true }, props.billingState)),
        react_1.default.createElement(ZipCodeField_1.default, __assign({ name: 'billingZipCode', required: true }, props.billingZipCode))));
    if (layout === 'compact') {
        monthYearCvv = (react_1.default.createElement(FormRow_1.default, { breakpoint: 'sm' },
            react_1.default.createElement(CardExpMonthField_1.default, __assign({ fieldBasis: '40%' }, props.expMonth, { required: true })),
            react_1.default.createElement(CardExpYearField_1.default, __assign({ fieldBasis: '40%' }, props.expYear, { required: true })),
            react_1.default.createElement(CardCVVField_1.default, __assign({ fieldBasis: '20%' }, props.cvv, { required: true }))));
        cityStateZipcode = (react_1.default.createElement(FormRow_1.default, { breakpoint: 'sm' },
            react_1.default.createElement(CityField_1.default, __assign({ name: 'billingCity', required: true }, props.billingCity)),
            react_1.default.createElement(StateField_1.default, __assign({ name: 'billingState', required: true }, props.billingState)),
            react_1.default.createElement(ZipCodeField_1.default, __assign({ name: 'billingZipCode', required: true }, props.billingZipCode))));
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(BillingFirstNameField_1.default, __assign({ required: true }, props.billingFirstName)),
        react_1.default.createElement(BillingLastNameField_1.default, __assign({ required: true }, props.billingLastName)),
        react_1.default.createElement(CardNumberField_1.default, __assign({ required: true }, props.cardNumber)),
        monthYearCvv,
        react_1.default.createElement(BillingAddressField_1.default, __assign({ required: true }, props.billingAddress)),
        react_1.default.createElement(BillingAddress2Field_1.default, __assign({}, props.billingAddress2)),
        cityStateZipcode));
}
exports.default = PaymentForm;
